import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Button } from '../components';
import { ResourceActions } from '../actions';
import { fetchTypes, routes } from '../constants';
import store from '../store';

class ApprovalGridCell extends React.Component {

    approveUser(id, role) {
        store.dispatch(ResourceActions.resourceFetch(fetchTypes.USER_APPROVE, { userId: id + '', role: role }));
        browserHistory.push(routes.SET_SECURITY + `?id=${id}`);
    }

    rejectUser(id) {
        store.dispatch(ResourceActions.resourceFetch(fetchTypes.USER_REJECT, { userId: id + '' }));
    }

    render() {
        return (
            <span className="component-approval-grid-cell">
                <Button onClick={() => this.approveUser(this.props.rowData.userId, this.props.rowData.roles)}>Yes</Button>
                <Button onClick={() => this.rejectUser(this.props.rowData.userId)}>No</Button>
            </span>
        )
    }
}

const select = (state) => {
    return {
        queue: state.userApprovalQueue
    }
}

export default connect(select)(ApprovalGridCell);



// WEBPACK FOOTER //
// ./web-app/components/approval-grid-cell.jsx